import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import WellnessProfessionalsStyle from './WellnessProfessionals.style';
import HippaIconSection from '@Components/Common/HippaIconSection';
import { LeftRightDesginIcon, LinkAnchor, refferalRouting } from '@Components/Common/CommonMethods';
import { useRouter } from 'next/router';
import ProfessionalRetailerPopup from '@PagesComponent/Professional_RetailerPopup';
import ViewCartPopup from '@Components/ViewCartPopup';
import IngredientList from '@Components/Common/IngredientList/IngredientList';
import VedioPlayer from '@Components/Common/VedioPlayer';
import { useRef } from 'react';
import Slider from 'react-slick';



const WellnessProfessionals = (props) => {

    const [openPopup, setOpenPopup] = useState(false);
    const [loginToken, setLoginToken] = useState(false);
    const [activeVideo, setActiveVideo] = useState(0);

    const handleBeforeChange = (oldIndex, newIndex) => {
        setActiveVideo(newIndex);
    };

    function handleOpenPopup() {
        document.body.classList.add('professional_retailer_form_popup');
        setOpenPopup(true)
    }

    const settings_6 = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        lazyLoad: 'progressive',
        speed: 1000,
        autoplaySpeed: 3000,
        arrows: false,
        beforeChange: handleBeforeChange,
    };

    useEffect(() => {
        if (localStorage.getItem('Token')) {
            setLoginToken(true);
        } else {
            setLoginToken(false);
        }
    }, []);

    const router = useRouter();
    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpenPopup(false);
                document.body.classList.remove('professional_retailer_form_popup');
                //   onClose()
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [openPopup]);

    function WellnessProfessionalShare() {
        if (loginToken) {
            router?.push("/us/user/become_wellness/")
        }
        else {
            router.push('/us/signup?d=is_professional/')

        }
    }


    return (

        <WellnessProfessionalsStyle>
            <div className='main_wellnessProfessionals_section' ref={ref}>
                <LeftRightDesginIcon>
                    <div className='title_sections'>
                        <h2>Wellness Professionals</h2>
                        <h3>We Remove The Guesswork So You Can Practice Smarter.</h3>
                    </div>
                    <div className="VideoSliderWrap">
                        <Slider {...settings_6}>
                            <div>
                                <div className="video_sec">
                                    {activeVideo === 0 ? (
                                        <iframe
                                            width="1829"
                                            height="763"
                                            src="https://www.youtube.com/embed/5KNekvS_hiM?rel=0"
                                            title="Wellness Coach Sachin Patel Reveals His Secret to Optimal Health: CODE Complex"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerpolicy="strict-origin-when-cross-origin"
                                            allowfullscreen
                                        />
                                    ) : null}
                                </div>
                            </div>

                            <div>
                                <div className="video_sec">
                                    <VedioPlayer
                                        url="https://player.vimeo.com/video/970149490?autoplay=false&loop=0&autopause=0&muted=0"
                                        active={activeVideo === 0}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="video_sec">
                                    <VedioPlayer
                                        url="https://player.vimeo.com/video/824948901?autoplay=false&loop=0&autopause=0&muted=0"
                                        active={activeVideo === 2}
                                    />
                                </div>
                            </div>
                        </Slider>
                    </div>
                    <div className='text_container'>
                        <div className='container'>
                            <div className='d-flex row'>
                                <div className='col-md-6'>
                                    <div className='first_content_section'>
                                        <p>
                                            DNA is complex. We custom formulate powerful,
                                            foundational nutrition based on your patients' and
                                            clients' unique, genetic vulnerabilities. Backed by over
                                            thirty years of research, our DNA-based precision
                                            nutrition is a simple, affordable solution for your
                                            medical or wellness practice.
                                        </p>
                                        <div className='image_text_one'>
                                            <div className='image'>
                                                <img src="/images/book_image.png" />
                                            </div>
                                            <div className='content'>
                                                <p>
                                                    Our DNA reports are ideal
                                                    for any healthcare
                                                    practice because they
                                                    cover actionable SNPs
                                                    and include relevant,
                                                    scientifically validated
                                                    information that's easy to
                                                    both explain and integrate
                                                    into any wellness plan.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='image_text_two'>
                                            <div className='content'>
                                                <p>
                                                    Our personalized, DNA-based
                                                    nutritional supplement addresses
                                                    patients' unique genetic challenges
                                                    while helping to reduce pill
                                                    fatigue, complex supplement
                                                    routines, and confusion.
                                                </p>
                                            </div>
                                            <div className='image'>
                                                <img src="/images/code_comple.png" loading='lazy' alt='complex' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='second_content_section'>
                                        <div className='message_tip'>
                                            <div className='image'>
                                                <img src="/images/background-quote.png" />
                                            </div>
                                            <div className='content-quote'>
                                                <p>
                                                    “I am fascinated by what SNiP Nutrigenomics has
                                                    brought to market. DNA is complex and there are so
                                                    many companies out there that do testing... but the
                                                    fact that SNiP focuses on actionable genes (and can
                                                    formulate for them) is truly revolutionary. I have
                                                    reviewed their science and can't wait to offer this to
                                                    my patients.”
                                                </p>
                                                <span>Dr. B, Dallas, Texas</span>
                                            </div>
                                        </div>
                                        <div className='content'>
                                            <p>
                                                To ensure quality and privacy, DNA analysis is
                                                performed in a US laboratory that is CLIA-certified and
                                                HIPPA compliant. The ingredients used to make our
                                                products are third-party tested to ensure they meet our
                                                highest quality standards, and manufacturing occurs in
                                                a U.S. based cGMP Compliant facility.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='button_sections'>
                            <LinkAnchor href={refferalRouting('/us/wellness_professionals/wellness_form/')}>
                                <button className='learn_more'>LEARN MORE</button>
                            </LinkAnchor>

                            {/* <button className='btn-primary-btn'>
                                <a href="https://admin.snipnutrition.com/media/documents/SNIP_Wellness_Professional_Program_Document.pdf" target='_blank'>WELLNESS PROFESSIONAL PROGRAM</a>
                            </button> */}


                            <button className='join_as_button' onClick={() => WellnessProfessionalShare()}>{!loginToken ? "JOIN AS A WELLNESS PROFESSIONAL NOW" : "BECOME A WELLNESS PROFESSIONAL"}</button>

                        </div>
                        <IngredientList />
                    </div>
                    {openPopup && <ProfessionalRetailerPopup open={openPopup} setOpen={setOpenPopup} section="professional" plan="Wellness Professional" />}
                    <HippaIconSection />
                </LeftRightDesginIcon>
            </div>
        </WellnessProfessionalsStyle>
    )
}

WellnessProfessionals.propTypes = {};

export default WellnessProfessionals;
